import { MaintenanceWindowSelectorBaseDataProvider } from './MaintenanceWindowSelectorBaseDataProvider';
import { MaintenanceWindowSelectorWebComponentSchema } from '../types';

export class MaintenanceWindowSelectorGzDataProvider extends MaintenanceWindowSelectorBaseDataProvider {
  async getDataForView(
    type: number,
    companyId: string,
    selectedMaintenanceWindowId: string
  ): Promise<MaintenanceWindowSelectorWebComponentSchema> {
    const response = await this.dependencies.api.clients.MaintenanceWindows.getMaintenanceWindowsForPolicy(
      type,
      companyId,
      selectedMaintenanceWindowId
    );

    return {
      maintenanceWindows: response,
    };
  }
}
